import React, {useRef, useState, useEffect} from 'react';
import {
  Box,
  Flex,
  Stack,
  Radio,
  Button,
  RadioGroup,
  Heading,
  Checkbox,
  Divider,
  Spacer,
  Link,
  StackDivider,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Thead,
  TableContainer,
  Tbody,
  Tr,
  Td,
  Input,
  Text,
} from '@chakra-ui/react';
import {set, useForm} from 'react-hook-form';
import BoxCard from '../../components/General/BoxCard';
import {CustomInput, SubmitButton, DatePicker, CustomSelect, CustomButton, CustomCheckbox} from '../../components/General/FormInputs';
import {useNavigate} from 'react-router-dom';
import LinkButton from '../../components/General/LinkButton';
import FlexCard from '../../components/General/FlexCard';
import {Batch, Client, Report, SurveyPrints} from '../../service/Urls';
import ResetPassword from '../Login/ResetPassword';
import {post, get, queryStringBuilder, getFile} from '../../service/ApiService';
import ErrorHelper from '../../service/ErrorHelper';
import ModalYesNo from '../../components/General/ModalYesNo';
import {useLocation} from 'react-router-dom';
import {Spinner} from '@chakra-ui/react';
import LoadingWheel from '../../components/General/LoadingWheel';
import {getCodeByKey, getValueByCode} from '../../helpers/ServiceTypeDictionary';
const Survey = () => {
  const location = useLocation();
  const [batchData, setBatchData] = useState(1);
  // const [CFSSummary, setCFS] = useState(1);
  const [surveyType, setSurveyType] = useState('1');
  // const [preNeed, setPreNeed] = useState(1);
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(true);
  //const batchId = 'Ky38OK2Z7LMz';
  const [toast, setToast] = useState('');
  const [pdfUrl, setPdfUrl] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const linkRef = useRef(null);
  const [missingReportData, setMissingReportData] = useState([]);
  const {isOpen: isOpenRegModal, onOpen: OnOpenRegModal, onClose: onCloseRegModal} = useDisclosure();
  const {isOpen: isOpenReportModal, onOpen: onOpenReportModal, onClose: onCloseReportModal} = useDisclosure();
  const {isOpen: isOpenUpdateModal, onOpen: onOpenUpdateModal, onClose: onCloseUpdateModal} = useDisclosure();
  const [pages, setPages] = useState({
    pageNum: 1,
    totalPages: 1,
    itemsPerPage: 500,
    getNewPage: curPage => {
      loadData(curPage);
    },
  });
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: {errors},
  } = useForm();

  const {isOpen, onOpen, onClose} = useDisclosure();
  // const loadData = async search => {
  //  console.log(search);
  // };
  useEffect(() => {
    if (pdfUrl.length > 0) linkRef.current.click();
  }, [pdfUrl]);

  useEffect(() => {
    loadData(location?.state?.id);
  }, []);
  const loadData = async id => {
    const response = await get(Batch.FetchBatch + id);

    if (!response.error) {
      response.bmSdate = response.bmSdate.substring(0, response.bmSdate.indexOf('T'));
      response.bmEdate = response.bmEdate.substring(0, response.bmEdate.indexOf('T'));
      response.dateAdded = response.dateAdded.substring(0, response.dateAdded.indexOf('T'));
      setBatchData(response);
      reset(response);
    }
  };
  async function GenerateEmailTexts() {
    handleSubmit(async data => {
      data.startDate = data.startDate.replaceAll('-', '');
      data.endDate = data.endDate.replaceAll('-', '');
      data.letterDate = data.letterDate.replaceAll('-', '');

      const params = {
        startDate: data.startDate,

        endDate: data.endDate,

        letterDate: data.letterDate,

        // CHANGE WHEN LIST OF BATCHES IS GOOD
        // batchNumber: batchId,

        //  clientId: data.clientId,
      };

      const url = queryStringBuilder(SurveyPrints.SendRegEmailsButton);
      const response = await post(url, params);
      setToast({response: response, successMessage: 'Emails/texts processing.'});
      onClose();
    })();
  }
  async function PrintLetter() {
    setIsLoading(true);
    handleSubmit(async data => {
      const params = {
        //  ClientId: data.clientID,
        Batch: data.bmNumber,
        CSvcType: data.csvctype,
        ServiceType: getValueByCode(data.csvctype),
        ReportType: 2,
        StartDate: data.startDate,
        EndDate: data.endDate,
        letterDate: data.letterDate,
      };

      setIsLoading(true);

      const urlCheck = queryStringBuilder(SurveyPrints.reportbuttonFileStatus, params);
      const checkResponse = await get(urlCheck);
      if (!checkResponse.error) {
        if (checkResponse.missingReports?.length > 0) {
          setMissingReportData(checkResponse.missingReports);
          onOpenReportModal();
        }
      }

      const url = queryStringBuilder(`${Report.GET_SURVEY_LETTERS}`, params);
      const response = await getFile(url);

      // setPdfUrl(fileURL);
      if (!response.error) {
        const fileURL = window.URL.createObjectURL(response);
        setPdfUrl(fileURL);
        // return fileURL;
      } else {
        setToast({response: response});
      }
      setIsLoading(false);
      // }
      // } else {
      //   setToast(response);
      // }

      // navigate('/reports/viewer', {state: {id: 1, reportName: response.reportName, reportParams: reportParams}});
    })();
    setIsLoading(false);
  }

  async function PrintSurvey() {
    handleSubmit(async data => {
      if (data.letterDate == null || data.letterDate == '') setToast({response: {Error: 'Please enter a survey letter date.'}});
      // data.startDate = data.startDate.replaceAll('-', '');
      // data.endDate = data.endDate.replaceAll('-', '');
      // data.letterDate = data.letterDate.replaceAll('-', '');
      const params = {
        // ClientId: data.clientID,
        Batch: data.bmNumber,
        CSvcType: data.csvctype,
        ServiceType: getValueByCode(data.csvctype),
        ReportType: 1,
        StartDate: data.startDate,
        EndDate: data.endDate,
        letterDate: data.letterDate,
      };

      setIsLoading(true);

      const urlCheck = queryStringBuilder(SurveyPrints.reportbuttonFileStatus, params);
      const checkResponse = await get(urlCheck);
      if (!checkResponse.error) {
        if (checkResponse.missingReports?.length > 0) {
          setMissingReportData(checkResponse.missingReports);
          onOpenReportModal();
        }
      }

      const url = queryStringBuilder(`${Report.GET_SURVEYS}`, params);

      const response = await getFile(url);
      if (response.error) {
        setToast(response);
      } else {
        // setPdfUrl(fileURL);
        if (!response.error) {
          const fileURL = window.URL.createObjectURL(response);
          setPdfUrl(fileURL);
          // return fileURL;
        }
      }
      setIsLoading(false);
      //   }
      // } else {
      //   setToast(checkResponse);
      // }
    })();
    setIsLoading(false);
  }

  // REPLACE WITH GETTER FOR MASS PRINTS
  async function PrintList() {
    handleSubmit(async data => {
      const reportParams = {
        StartDate: data.startDate,
        EndDate: data.endDate,
        letterDate: data.letterDate,
        CSvcType: getCodeByKey(data.ServiceType),
        Batch: data.bmNumber,
      };
      setIsLoading(true);
      const url = queryStringBuilder(`${Report.DEFAULT_REPORT}surveyL.rdlx`, reportParams);
      const response = await getFile(url);
      setIsLoading(false);
      if (!response.error) {
        const fileURL = window.URL.createObjectURL(response);
        setPdfUrl(fileURL);
        // return fileURL;
      } else {
        setToast(response);
      }
      // navigate('/reports/viewer', {state: {id: 1, reportName: 'Surveys1.rdlx', reportParams: reportParams}});
    })();
  }

  async function UpdateClick() {
    handleSubmit(async data => {
      const url = `${SurveyPrints.UpdateBatch}`;
      const params = {
        batchId: location?.state?.id,

        endDate: data.endDate,

        startDate: data.startDate,

        isElectronic: data.isElectronic,
        letterDate: data.letterDate,
      };
      const response = await post(url, params);
      // setToast({response: response, successMessage: 'Success'});

      const urlReg = `${SurveyPrints.SendRegNumbers}`;
      const responseReg = await post(urlReg);
      setToast(responseReg);
      const emailurl = queryStringBuilder(SurveyPrints.SendRegEmailsButton);
      const emailResponse = await post(emailurl, params);
      setToast({response: emailResponse, successMessage: 'Emails/texts processing.'});

      onCloseUpdateModal();
    })();
  }

  async function UnUpdateClick() {
    handleSubmit(async data => {
      const params = {
        batchId: location?.state?.id,

        endDate: data.endDate,

        startDate: data.startDate,

        isElectronic: data.isElectronic,
        letterDate: data.letterDate,
      };
      const url = `${SurveyPrints.UnUpdateBatch}`;
      const response = await post(url, params);
      setToast({response: response, successMessage: 'Success'});
    })();
  }

  const filledCheck = () => {
    // initially made it using jquery syntax before realizing that there is no jquery. found my js only solution here: https://stackoverflow.com/questions/588263/how-can-i-get-all-a-forms-values-that-would-be-submitted-without-submitting

    // this grabs the elements value and then diables the disable
    const formEl = document.forms.Survey;
    const formData = new FormData(formEl);
    const sDate = formData.get('startDate');
    const eDate = formData.get('endDate');
    const radios = document.getElementsByName('radio');

    let radio = document.createElement('radio');
    for (let x = 0; x < radios.length; x++) {
      if (radios[x].checked) {
        radio = radios.item(x);
      }
    }
    if (sDate != null && eDate != null && radio != null) {
      setIsDisabled(false);
    }
  };
  const navToSearch = () => {
    navigate('/surveys/batch');
  };
  return (
    <form id="Survey" onChange={filledCheck} /* {onSubmit={handleSubmit(printSurvey)} }*/>
      <Flex flexDir={{base: 'column', xl: 'row'}}>
        {/* Survey Printing */}
        <Box w="100%" mr="3">
          <BoxCard py="5">
            <Stack w="100%" minW="450px" h={{base: 'auto', xl: '1px'}} minH="500px">
              <Heading>Batch Printing</Heading>
              <Divider my="3" />
              <Flex w="100%" flexDir={{base: 'column', xl: 'row'}}>
                <Stack w={{base: '100%', xl: '34%'}} justify={{base: 'center', xl: 'left'}} minW="200px">
                  <Flex flexDir={{base: 'column', xl: 'row'}}>
                    <CustomInput register={register} errors={errors} id="bmNumber" name="Batch Number" disabled={true} />
                    <Input type="hidden" id="npk" isReadOnly={true} />
                    <Input type="hidden" id="csvctype" isReadOnly={true} />
                    <Input type="hidden" id="clientId" isReadOnly={true} />
                    <Input type="hidden" id="batchId" isReadOnly={true} />
                    <Stack>
                      <Text></Text>

                      <ModalYesNo
                        isOpen={isOpenRegModal}
                        onOpen={OnOpenRegModal}
                        onClose={onCloseRegModal}
                        title="Confirmation"
                        body={'Are you sure you want to generate Email/Texts now?'}
                        yesFunction={GenerateEmailTexts}
                      />
                      <ModalYesNo
                        isOpen={isOpenUpdateModal}
                        onOpen={onOpenUpdateModal}
                        onClose={onCloseUpdateModal}
                        title="Confirmation"
                        body={'Are you sure you want to set records sent date to the letter date, between the chosen dates?'}
                        yesFunction={UpdateClick}
                      />
                    </Stack>
                  </Flex>
                  <Flex flexDir={{base: 'column', xl: 'row'}}>
                    <CustomInput register={register} errors={errors} id="bmClient" name="Client ID" disabled={true} />
                    <CustomInput register={register} errors={errors} id="clientName" name="Client Name" disabled={true} />
                  </Flex>
                  <Flex flexDir={{base: 'column', '2xl': 'row'}}>
                    <DatePicker
                      id="dateAdded"
                      name="Imported Date"
                      register={register}
                      errors={errors}
                      required
                      mr={{base: '0', xl: '3'}}
                      disabled={true}
                    />
                    <DatePicker
                      id="bmSdate"
                      name="Contracts From"
                      register={register}
                      errors={errors}
                      required
                      mr={{base: '0', xl: '3'}}
                      disabled={true}
                    />
                    <DatePicker
                      id="bmEdate"
                      name="Contracts To"
                      register={register}
                      errors={errors}
                      required
                      mr={{base: '0', xl: '3'}}
                      disabled={true}
                    />
                  </Flex>
                </Stack>
                <Divider mx="3" orientation="vertical" />
                <Stack w={{base: '100%', xl: '66%'}} minW="200px">
                  <Flex flexDir={{base: 'column', xl: 'row'}}>
                    <Stack w={{base: '100%', xl: '50%'}}>
                      <Heading size="lg">Status At Time of Import</Heading>
                      <CustomInput register={register} errors={errors} id="bmRecords" name="No. of Valid Records" disabled={true} />
                      <CustomInput register={register} errors={errors} id="bmExcept" name="No. of Exceptions" disabled={true} />
                      <CustomInput register={register} errors={errors} id="bmDupes" name="No. of Duplicates" disabled={true} />
                    </Stack>
                    <Divider mx="3" orientation="vertical" />
                    <Stack w={{base: '100%', xl: '50%'}}>
                      <Heading size="lg">Current Status</Heading>
                      <CustomInput register={register} errors={errors} id="currentValid" name="No. of Valid Records" disabled={true} />
                      <CustomInput register={register} errors={errors} id="currentExceptions" name="No. of Exceptions" disabled={true} />
                      <CustomInput register={register} errors={errors} id="currentDeleted" name="No. of Duplicates" disabled={true} />
                      <CustomInput register={register} errors={errors} id="currentPrinted" name="No. Printed" disabled={true} />
                    </Stack>
                  </Flex>
                </Stack>
              </Flex>
              <Divider my="3" />
              <Flex justify="center" flexDir={{base: 'column', xl: 'row'}}>
                <Text mt={5} fontSize="lg">
                  Date Range to Print:
                </Text>
                <DatePicker id="startDate" name="Starting Date" register={register} errors={errors} required mx={{base: '0', xl: '3'}} />
                <DatePicker id="endDate" name="Ending Date" register={register} errors={errors} required mx={{base: '0', xl: '3'}} />
                <DatePicker id="letterDate" name="Date for Survey Letter" register={register} errors={errors} required mx={{base: '0', xl: '3'}} />
              </Flex>
              <Divider />
              {isLoading ? (
                <Flex my="4">
                  <Spacer />
                  <LoadingWheel />
                  <Spacer />
                </Flex>
              ) : (
                <Flex flexDir="row" my="4">
                  <Spacer />
                  <Box>
                    <LinkButton id="formButton" to="/surveys/batch" label="Back" mx="3" />
                  </Box>
                  <Button colorScheme="secondary" mx="3" onClick={PrintLetter}>
                    Print Letter
                  </Button>
                  <Button colorScheme="secondary" mx="3" onClick={PrintSurvey}>
                    Print Survey
                  </Button>
                  <Button colorScheme="secondary" mx="3" onClick={PrintList}>
                    Print List
                  </Button>
                  <Button colorScheme="secondary" mx="3" onClick={onOpenUpdateModal}>
                    Update
                  </Button>
                  <Button colorScheme="secondary" mx="3" onClick={UnUpdateClick}>
                    Un-Update
                  </Button>
                  <Spacer />
                </Flex>
              )}
            </Stack>
          </BoxCard>
          <Modal blockScrollOnMount={false} size={'4xl'} isOpen={isOpenReportModal} onClose={onCloseReportModal}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader id="header">Missing Reports</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Divider mt="5" colorScheme={'mint'} width={{base: '100%'}} />
                <TableContainer width={{base: '100%'}}>
                  <Table variant="striped" border="solid 2px #0c5f78" colorScheme="mint" size={'md'}>
                    <Thead>
                      <Tr border="solid 2px #0c5f78">
                        <Td>ClientID</Td>
                        <Td>Report Name</Td>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {missingReportData.map(missingreport => {
                        return (
                          <Tr key={missingreport.clId}>
                            <Td>{missingreport.clId}</Td>
                            <Td>{missingreport.reportName}</Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </ModalBody>

              <ModalFooter>
                <CustomButton name="Close" mr={3} onClick={onCloseReportModal} />
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      </Flex>
      <a href={pdfUrl} target="_blank" rel="noopener noreferrer" ref={linkRef} style={{display: 'none'}} />
      <ErrorHelper toastResponse={toast} />
    </form>
  );
};

export default Survey;
